import { Button, List, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { useDialog } from "lib/@hooks/useDialog"
import { getRegisterAccess } from "routes/client-admin/plugins/asset-register-access/controller/getRegisterAccess"
import { uniqueId } from "library/database/split-id.mjs"
import { getRegisterToken } from "routes/client-admin/plugins/asset-register-access/controller/getRegisterToken"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { createRegisterAccess } from "routes/client-admin/plugins/asset-register-access/controller/createRegisterAccess"
import { OneCard } from "lib/@components/one-card"
import { useEffect, useState } from "react"
import CopyClipboard from "minimals-template/components/CopyClipboard"
import { RequestPageRepeat } from "lib/@components/request-page-repeat"
import { RegisterAccessItem } from "routes/client-admin/plugins/asset-register-access/register-access-item"
import { RegisterAccessDialog } from "routes/client-admin/plugins/asset-register-access/register-access-dialog"
import { useSearchParam } from "lib/@hooks/use-search-param"
import { SearchBoxUsingSearchParam } from "lib/@components/searchBoxUsingSearchParam"
import { If } from "lib/@components/switch"

export function RegisterAccess() {
    const [search] = useSearchParam("search")
    const [skip, setSkip] = useState(0)
    const { currentClient } = useBoundContext()
    const client = uniqueId(currentClient)
    const create = useDialog(<RegisterAccessDialog />)

    const {
        loading: accessLoading,
        data: accessData,
        error: accessError,
    } = getRegisterAccess.useResults.status({ search, skip, take: 10 })

    const { loading: tokenLoading, data: registerToken, error: tokenError } = getRegisterToken.useResults.status(client)

    const { total, data: registerAccess } = accessData || {}

    const [renderClipboard, setRenderClipboard] = useState(false)

    useEffect(() => {
        const shouldRender = !(accessLoading || accessError || tokenLoading || tokenError)
        setRenderClipboard(shouldRender)
    }, [accessLoading, accessError, tokenLoading, tokenError])

    return (
        <>
            <OneCard sx={{ m: 1, p: 2 }}>
                <Stack spacing={2} sx={{ mt: 0, mb: 3 }}>
                    <Typography>
                        Asset Register Tokens allow authorised API users to access your asset registers. Add
                        authorisation below
                    </Typography>
                    <Stack width={300} spacing={2}>
                        <Typography variant="h6" noWrap>{`Asset Register Token:`}</Typography>
                        <If truthy={renderClipboard}>
                            <CopyClipboard data-cy="register-token-clipboard" readOnly value={registerToken} />
                        </If>
                    </Stack>
                    <SearchBoxUsingSearchParam data-cy="access-search-box" placeholder="Search for domains..." />
                    <List data-cy="register-access-list">
                        <RequestPageRepeat
                            total={total}
                            pageSize={10}
                            setSkip={setSkip}
                            list={registerAccess}
                            item={<RegisterAccessItem />}
                        />
                    </List>
                    <Button data-cy="add-access-button" onClick={addAccess} variant="contained">
                        Add Access
                    </Button>
                </Stack>
            </OneCard>
        </>
    )

    async function addAccess() {
        try {
            const { authorisedDomain = null } = (await create()) || {}
            if (authorisedDomain) {
                await createRegisterAccess(authorisedDomain)
                successSnackbar(`Added domain access for ${authorisedDomain}`)
            }
        } catch (e) {
            errorSnackbar("Failed to add domain access")
        }
    }
}
